import Page from 'src/event/[entityId]/embed/[unlisted_hash]/interaction/index';

export default Page;
